import { api } from "./api";
import {
  ContactStatus,
  Contact,
  BaseContactLink,
  ContactLink,
} from "../../types/ContactTypes";

export interface ContactsResponse {
  results: Contact[];
}

export const contactsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getContacts: builder.query<ContactsResponse, void>({
      query: () => ({
        url: "/contacts/",
      }),
      providesTags: (res) =>
        res?.results
          ? [
              ...res?.results?.map(({ id }) => ({
                type: "Contacts" as const,
                id,
              })),
              { type: "Contacts", id: "LIST" },
            ]
          : [{ type: "Contacts", id: "LIST" }],
    }),
    getContactLink: builder.query<ContactLink, string>({
      query: (id: string) => ({
        url: `/contact-links/${id}/`,
      }),
    }),
    createContact: builder.mutation<BaseContactLink, BaseContactLink>({
      query: (contact) => ({
        url: "/contact-links/",
        method: "POST",
        body: contact,
      }),
      invalidatesTags: ["Contacts"],
    }),
    removeContact: builder.mutation<void, Contact>({
      query: (contact) => ({
        url:
          contact.status === ContactStatus.Verified
            ? `/contacts/${contact.id}/remove/`
            : `/contact-links/${contact.id}/`,
        method: contact.status === ContactStatus.Verified ? "POST" : "DELETE",
      }),
      invalidatesTags: ["Contacts"],
    }),
    acceptContactLink: builder.mutation<void, { id: string }>({
      query: (contact) => ({
        url: `/contact-links/${contact.id}/accept/`,
        method: "POST",
        body: {},
      }),
      invalidatesTags: ["Contacts"],
    }),
    resendContactLink: builder.mutation<void, { id: string }>({
      query: (contact) => ({
        url: `/contact-links/${contact.id}/resend/`,
        method: "POST",
        body: {},
      }),
      invalidatesTags: ["Contacts"],
    }),
  }),
});

export const {
  useGetContactsQuery,
  useGetContactLinkQuery,
  useCreateContactMutation,
  useRemoveContactMutation,
  useAcceptContactLinkMutation,
  useResendContactLinkMutation,
} = contactsApi;
